import type { FaireProductEntity } from "../../entity_types/product";

export const p_b2chvcwprs: FaireProductEntity = {
  token: "p_b2chvcwprs",
  type: "product",
  name: "SMARTIES - Candy Monies 141g (8 Pack)",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/bb8bf33df67e5b0bbff8ce03db839818529cd270301e0791d136f94ef51ec601.jpeg",
  galleryImageUrls: [],
  priceDollars: 45,
  description:
    "Turn candy into cash with Smarties Candy Monies 💰🍬\n\nThese fun, coin-shaped Smarties deliver the same classic sweet-and-tangy fruity flavor, but in a playful money-themed design that makes them perfect for events, parties, and impulse sales.\n\nEach roll features larger tablet candies stamped with dollar amounts, giving customers a nostalgic treat with a unique twist. Packed in a convenient 8-pack, this is a strong grab-and-go or bundle-friendly SKU that stands out on shelves.\n\n\n\n\n\n🔥 Why Customers Love It\n\n• 💰 Unique “candy money” coin design\n• 🍬 Classic Smarties sweet + tangy flavor\n• 🎉 Perfect for parties, events & themed displays\n• 📦 8-pack format = great for resale or bundles\n• 🌱 Vegan, gluten-free, allergen-friendly\n• 📈 High impulse buy potential\n\nSmarties products are widely known for being free from major allergens and suitable for many diets, making them an easy sell across all customer types\n",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:30.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
